var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 20",
    style: {
      enableBackground: "new 0 0 23 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M11.5,20l-1.7-1.4C3.9,13.5,0,10.1,0,6c0-3.4,2.8-6,6.3-6c2,0,3.9,0.9,5.2,2.3 C12.8,0.9,14.7,0,16.7,0C20.2,0,23,2.7,23,6c0,4.1-3.9,7.5-9.8,12.5L11.5,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeart);
export default __webpack_public_path__ + "static/media/red-heart.02de626f7c19c5a8dbff7d9392772014.svg";
export { ForwardRef as ReactComponent };